import Modal from "../../../tailadmin/components/ui/Modal";
import utils from "../../../helpers/utils";
import Strings from "../../../constants/Strings";
import {
  FiRefreshCw,
  FiSave,
  FiX,
  FiMail,
  FiPhone,
  FiCalendar,
  FiUser,
} from "react-icons/fi";
import { useEffect, useState, ChangeEvent } from "react";
import plans from "../../../services/plans";
import students from "../../../services/students";
import { useAuth } from "../../../context/AuthContext";
import { Plan, WorkoutPlan, Avaliation, Tracking, User } from "../../../types";
import TrainItem from "../../workouts/TrainItem";
import AvaliationItem from "../../avaliations/AvaliationItem";
import Button from "../../ui/Button";
import Load from "../../ui/Load";
import { usePrescription } from "../../../context/PrescriptionContext";
import avaliations from "../../../services/avaliations";
import Chart from "../../charts/Chart";
import Card from "../../ui/Card";
import InputDefault from "../../ui/InputDefault";
import { toast } from "react-toastify";

interface StudentModalProps {
  onBack: () => void;
  isOpen: boolean;
  data: User | null;
  buttonOff?: boolean;
}

function StudentModal({ onBack, isOpen, data, buttonOff }: StudentModalProps) {
  const [load, setLoad] = useState(true);
  const [planos, setPlanos] = useState<Plan[]>([]);
  const [treinos, setTreinos] = useState<WorkoutPlan[]>([]);
  const [avaliacao, setAvaliacao] = useState<Avaliation[]>([]);
  const [tracking, setTracking] = useState<Tracking[]>([]);

  const [vencimento, setVencimento] = useState<boolean | string>(false);

  const { newPrescription, addAvaliation, setWorkout, updateAvaliation } =
    usePrescription();
  const { getUser } = useAuth();

  const saveRenew = async () => {
    const prof_id = getUser()?.id;
    if (!prof_id || !data?.id) return;

    const res = await students.renew({
      user_id: String(data.id),
      professional_id: String(prof_id),
      new_validity: vencimento.toString(),
    });

    if (res) {
      setPlanos(await plans.get_plan(String(data.id)));
      setVencimento(false);
      toast.success("Validade alterada com sucesso!");
    }
  };

  const getPlans = async (id: string) => {
    setLoad(true);

    const prof_id = getUser()?.id;
    if (!prof_id) return;

    try {
      const [planos, treinos, avaliacao, track] = await Promise.all([
        plans.get_plan(id),
        students.get_all_prescription(String(prof_id), id),
        avaliations.listall(String(prof_id), id),
        students.list_all_(id),
      ]);

      setPlanos(planos);
      setTreinos(treinos);
      setAvaliacao(avaliacao);
      setTracking(track);
    } catch (error) {
      console.error("Error fetching plans:", error);
    }

    setLoad(false);
  };

  useEffect(() => {
    setPlanos([]);
    setTreinos([]);
    if (data && data?.id) getPlans(String(data.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!data) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onBack}
      title="Detalhes do Aluno"
      className="w-full max-w-full sm:max-w-5xl"
    >
      <div className="flex flex-col gap-4 sm:gap-6">
        {/* Header Profile */}
        <div className="flex flex-col md:flex-row gap-4 sm:gap-6 items-center md:items-start p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <img
            src={utils.getUriImage(data?.photo || Strings.default_photo)}
            alt={data?.name}
            className="w-24 h-24 rounded-full object-cover shadow-sm border-2 border-white dark:border-gray-700"
          />
          <div className="flex-1 w-full">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-2 text-center md:text-left">
              {data?.name}
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-sm text-gray-600 dark:text-gray-400">
              <div className="flex items-center gap-2">
                <FiMail className="text-brand-500" />
                <span>{data?.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <FiCalendar className="text-brand-500" />
                <span>
                  Cadastrado em:{" "}
                  {utils.formatDate(
                    data?.registe ? new Date(data.registe) : new Date(),
                  )}
                </span>
              </div>
              {data?.phone && (
                <a
                  className="flex items-center gap-2 hover:text-brand-600 transition-colors"
                  target="_blank"
                  rel="noreferrer"
                  href={`https://api.whatsapp.com/send/?phone=${data?.phone}&text&type=phone_number&app_absent=0`}
                >
                  <FiPhone className="text-green-500" />
                  <span>{utils.formatarTelefone(data?.phone)}</span>
                </a>
              )}
              {data?.gener && (
                <div className="flex items-center gap-2">
                  <FiUser className="text-brand-500" />
                  <span>{data?.gener}</span>
                </div>
              )}
            </div>

            {planos[0]?.end_date && (
              <div className="mt-4 flex items-center gap-3 p-3 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600">
                <span className="font-semibold text-gray-700 dark:text-gray-300">
                  Vencimento:
                </span>
                {!vencimento ? (
                  <span className="text-brand-500 font-bold">
                    {utils.formatDate(new Date(planos[0]?.end_date))}
                  </span>
                ) : (
                  <InputDefault
                    className="w-[150px] mb-0"
                    classNameInput="py-1"
                    type="date"
                    required={true}
                    onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
                      setVencimento(target.value);
                    }}
                  />
                )}

                <div className="flex items-center gap-2 ml-auto">
                  {vencimento ? (
                    <>
                      <button
                        onClick={() => setVencimento(false)}
                        className="p-1 text-gray-500 hover:text-red-500"
                      >
                        <FiX size={20} />
                      </button>
                      <button
                        onClick={() => saveRenew()}
                        className="p-1 text-brand-500 hover:text-brand-600"
                      >
                        <FiSave size={20} />
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={() => setVencimento("NOT")}
                      className="p-1 text-brand-500 hover:text-brand-600"
                      title="Renovar"
                    >
                      <FiRefreshCw size={20} />
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {load ? (
          <div className="flex justify-center p-8">
            <Load />
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Frequência Chart */}
            <div className="w-full">
              <Card
                title="Frequência"
                subtitle=" (últimos 7 dias)"
                className="w-full"
              >
                <Chart
                  sliceNum={-7}
                  sufix="%"
                  data={tracking.map((e) => ({
                    ...e,
                    count: e.count !== 0 ? 100 : 0,
                  }))}
                />
              </Card>
            </div>

            {/* Planos de Treino */}
            <div className="w-full">
              <div className="flex justify-between items-center mb-4">
                <h4 className="text-lg font-bold text-gray-900 dark:text-white">
                  Plano de Treino
                </h4>
                <div className="w-auto">
                  <Button
                    title="Novo"
                    className="py-2 px-4 text-xs"
                    onClick={() => newPrescription()}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-3 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
                {treinos.map((e) => (
                  <TrainItem
                    key={e.id}
                    data={e}
                    onClick={(a: WorkoutPlan) => setWorkout(a)}
                  />
                ))}
                {treinos.length === 0 && (
                  <p className="text-gray-500 text-sm">
                    Nenhum treino cadastrado.
                  </p>
                )}
              </div>
            </div>

            {/* Avaliações */}
            <div className="w-full lg:col-span-2">
              <div className="flex justify-between items-center mb-4">
                <h4 className="text-lg font-bold text-gray-900 dark:text-white">
                  Avaliações
                </h4>
                <div className="w-auto">
                  <Button
                    title="Nova Avaliação"
                    className="py-2 px-4 text-xs"
                    onClick={() =>
                      addAvaliation(String(data.id), String(getUser()?.id))
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
                {avaliacao.map((e) => (
                  <AvaliationItem
                    key={e.id}
                    data={e}
                    onClick={() => updateAvaliation(e, e.id)}
                  />
                ))}
                {avaliacao.length === 0 && (
                  <p className="text-gray-500 text-sm col-span-full">
                    Nenhuma avaliação cadastrada.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default StudentModal;
